import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../../../actions";

class Score extends Component {

  constructor(props) {
    super(props);
    this.state = {
      whackamoleScoreList: [],
    };
    this.inputField = React.createRef();
  }

  componentDidMount() {
    this.props.fetchWhackamoleGamesScores();
  }

  renderHighScore() {
    const { data } = this.props;
    const scores =  _.orderBy(data, ['score', 'createAt'], ['desc', 'asc']);
    if(scores.length !== 0 && scores[0].score > this.props.context.score) {
      return (
        <h6>&#127942; {scores[0].name} ({scores[0].score}) &#127942;</h6>
      );
    } else {
      return (
        <h6>&#127942; {this.props.context.score } &#127942;</h6>
      );
    }
  }

  render(){
    return (
      <div className="game__score" style={{ display: this.props.context.display }}>
        <h6>SCORE: {this.props.context.score}</h6>
        {this.renderHighScore()}
      </div>
    )
  };
}

const mapStateToProps = ({ data }) => {
  return {
    data,
  };
};

export default connect(mapStateToProps, actions)(Score);